import axios from 'axios'

var util = { };

util.title = function(title) {
    //title = title ? 'DESIGNMAN CMS - ' + title : 'DESIGNMAN CMS';
    window.document.title = title;
};

/*var ajaxUrl = process.env.NODE_ENV === 'development' ?
    'http://duty.dev.jettwork.com/api' :
    process.env.NODE_ENV === 'production' ?
    'http://duty.dev.jettwork.com/api' :
    'http://duty.dev.jettwork.com/api';*/
    
util.http = axios.create({
	//headers: { 'Access-Control-Allow-Origin': '*', },
	//withCredentials: true, //默认的false，表示跨域请求时是否需要使用凭证；未设置withCredentials 为true，那么就不能为它自己的域设置cookie值,
}); //不指定url

util.ajax = axios.create({
	//baseURL: ajaxUrl,
	timeout: 35000,
    responseType: 'json', // 默认的，表示服务器响应的数据类型，可以是 'arraybuffer', 'blob', 'document', 'json', 'text', 'stream'
	headers: {
		//'Content-Type': 'application/json; charset=UTF-8',
		//'Access-Control-Allow-Origin': '*',
		//'Authorization':localStorage.getItem("token"),
	},
	//withCredentials: false, //默认的false，表示跨域请求时是否需要使用凭证；未设置withCredentials 为true，那么就不能为它自己的域设置cookie值,
});

export default util;